import { useNoaIntegrationClient } from '@/clients';

import type {
  ApiClient,
  ApiClientResponse,
  CreateApiClientResponse,
  NewApiClient,
  RegenerateSecretResponse,
  UpdateApiClient,
} from '../types/api-client';
import type { Specialization } from '../types/specialization';

export function useApiClientService(): ApiClientService {
  const client = useNoaIntegrationClient();

  return new ApiClientService(client);
}

class ApiClientService {
  constructor(private readonly client: ReturnType<typeof useNoaIntegrationClient>) {}

  async getApiClients({
    page,
    pageSize,
    searchQuery,
  }: {
    page: number;
    pageSize: number;
    searchQuery: string;
  }): Promise<{
    items: ApiClient[];
    totalCount: number;
    pageNumber: number;
    pageSize: number;
  }> {
    return this.client.fetch({
      method: 'GET',
      url: '/consumers',
      params: {
        page,
        pageSize,
        searchQuery,
      },
    });
  }

  async getApiClient(id: string): Promise<ApiClientResponse> {
    return this.client.fetch({
      method: 'GET',
      url: `/consumers/${id}`,
    });
  }

  async createApiClient(apiClient: NewApiClient): Promise<CreateApiClientResponse> {
    return this.client.fetch({
      method: 'POST',
      url: `/consumers`,
      data: apiClient,
    });
  }

  async updateApiClient(apiClient: UpdateApiClient) {
    return this.client.fetch({
      method: 'PUT',
      url: `/consumers`,
      data: apiClient,
    });
  }

  async removeApiClient(id: string) {
    return this.client.fetch({
      method: 'DELETE',
      url: `/consumers/${id}`,
    });
  }

  async getSpecializations(countryCode: string): Promise<Specialization[]> {
    return this.client.fetch({
      method: 'GET',
      url: `/consumers/specialization?countryCode=${countryCode}`,
    });
  }

  async regenerateSecret(id: string): Promise<RegenerateSecretResponse> {
    return this.client.fetch({
      method: 'POST',
      url: `/consumers/${id}/regenerate-secret`,
    });
  }
}
